export default "__VITE_ASSET__BWLbNC9y__"